import type { PropsWithChildren, ReactNode } from "react";

import { Combobox, Option, Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import type { OptionValue } from "./types";

interface IFilterOptionProps {
    item: OptionValue;
    onClick: () => void;
    favicon?: string;
    chip?: ReactNode;
    isDisabled?: boolean;
    disabledTooltipContent?: string;
}

export const FilterOption = ({
    item,
    onClick,
    favicon,
    chip,
    isDisabled,
    disabledTooltipContent,
    children,
}: PropsWithChildren<IFilterOptionProps>) => (
    <Combobox.Option
        value={item}
        onClick={onClick}
        textValue={item.id}
        isDisabled={isDisabled}
    >
        <Tooltip
            enabled={Boolean(isDisabled && disabledTooltipContent)}
            content={disabledTooltipContent}
        >
            <Flex
                alignItems="center"
                justifyContent="space-between"
                gap="8px"
                width="100%"
            >
                <Flex
                    alignItems="center"
                    gap="8px"
                >
                    {favicon ? <Option.Favicon src={favicon} /> : null}
                    <Combobox.OptionLabel>{item.label}</Combobox.OptionLabel>
                    {chip}
                </Flex>
                {children}
            </Flex>
        </Tooltip>
    </Combobox.Option>
);
